var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_726583256"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M20 164l0 -57c0,-2 -1,-4 -3,-4 -2,0 -3,2 -3,4l0 57c0,2 1,4 3,4 2,0 3,-2 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M190 164l0 -57c0,-2 -2,-4 -4,-4 -2,0 -3,2 -3,4l0 57c0,2 1,4 3,4 2,0 4,-2 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M30 103c-1,0 -3,2 -3,4l0 30c0,2 2,4 3,4 2,0 4,-2 4,-4l0 -30c0,-2 -2,-4 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M41 103c-2,0 -4,2 -4,4l0 30c0,2 2,4 4,4 2,0 3,-2 3,-4l0 -30c0,-2 -1,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M61 137l0 -30c0,-2 -2,-4 -3,-4 -2,0 -4,2 -4,4l0 30c0,2 2,4 4,4 1,0 3,-2 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M71 137l0 -30c0,-2 -1,-4 -3,-4 -2,0 -4,2 -4,4l0 30c0,2 2,4 4,4 2,0 3,-2 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M81 137l0 -30c0,-2 -1,-4 -3,-4 -2,0 -3,2 -3,4l0 30c0,2 1,4 3,4 2,0 3,-2 3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M102 137l0 -30c0,-2 -2,-4 -4,-4 -2,0 -3,2 -3,4l0 30c0,2 1,4 3,4 2,0 4,-2 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 107c0,-2 -2,-4 -4,-4 -2,0 -3,2 -3,4l0 30c0,2 1,4 3,4 2,0 4,-2 4,-4l0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M129 107c0,-2 -2,-4 -4,-4 -2,0 -3,2 -3,4l0 30c0,2 1,4 3,4 2,0 4,-2 4,-4l0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M142 103c-2,0 -3,2 -3,4l0 30c0,2 1,4 3,4 2,0 4,-2 4,-4l0 -30c0,-2 -2,-4 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M152 103c-1,0 -3,2 -3,4l0 30c0,2 2,4 3,4 2,0 4,-2 4,-4l0 -30c0,-2 -2,-4 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M173 141c2,0 3,-2 3,-4l0 -30c0,-2 -1,-4 -3,-4 -2,0 -4,2 -4,4l0 30c0,2 2,4 4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M14 39l0 47c0,2 1,4 3,4 2,0 3,-2 3,-4l0 -47c0,-2 -1,-3 -3,-3 -2,0 -3,1 -3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M190 86l0 -47c0,-2 -2,-3 -4,-3 -2,0 -3,1 -3,3l0 47c0,2 1,4 3,4 2,0 4,-2 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M27 86c0,2 2,4 3,4 2,0 4,-2 4,-4l0 -47c0,-2 -2,-3 -4,-3 -1,0 -3,1 -3,3l0 47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M41 90c2,0 3,-2 3,-4l0 -47c0,-2 -1,-3 -3,-3 -2,0 -4,1 -4,3l0 47c0,2 2,4 4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M58 90c1,0 3,-2 3,-4l0 -47c0,-2 -2,-3 -3,-3 -2,0 -4,1 -4,3l0 47c0,2 2,4 4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M68 90c2,0 3,-2 3,-4l0 -47c0,-2 -1,-3 -3,-3 -2,0 -4,1 -4,3l0 47c0,2 2,4 4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M78 90c2,0 3,-2 3,-4l0 -47c0,-2 -1,-3 -3,-3 -2,0 -3,1 -3,3l0 47c0,2 1,4 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M98 90c2,0 4,-2 4,-4l0 -47c0,-2 -2,-3 -4,-3 -2,0 -3,1 -3,3l0 47c0,2 1,4 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M115 90c2,0 4,-2 4,-4l0 -47c0,-2 -2,-3 -4,-3 -2,0 -3,1 -3,3l0 47c0,2 1,4 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M125 90c2,0 4,-2 4,-4l0 -47c0,-2 -2,-3 -4,-3 -2,0 -3,1 -3,3l0 47c0,2 1,4 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M142 90c2,0 4,-2 4,-4l0 -47c0,-2 -2,-3 -4,-3 -2,0 -3,1 -3,3l0 47c0,2 1,4 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M152 90c2,0 4,-2 4,-4l0 -47c0,-2 -2,-3 -4,-3 -1,0 -3,1 -3,3l0 47c0,2 2,4 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M173 90c2,0 3,-2 3,-4l0 -47c0,-2 -1,-3 -3,-3 -2,0 -4,1 -4,3l0 47c0,2 2,4 4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M30 151c-1,0 -3,1 -3,3l0 3c0,2 2,4 3,4 2,0 4,-2 4,-4l0 -3c0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M41 151c-2,0 -4,1 -4,3l0 3c0,2 2,4 4,4 2,0 3,-2 3,-4l0 -3c0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M51 151c-2,0 -4,1 -4,3l0 3c0,2 2,4 4,4 2,0 3,-2 3,-4l0 -3c0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M61 151c-2,0 -3,1 -3,3l0 3c0,2 1,4 3,4 2,0 3,-2 3,-4l0 -3c0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M71 151c-2,0 -3,1 -3,3l0 3c0,2 1,4 3,4 2,0 4,-2 4,-4l0 -3c0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M81 151c-2,0 -3,1 -3,3l0 3c0,2 1,4 3,4 2,0 4,-2 4,-4l0 -3c0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M91 151c-1,0 -3,1 -3,3l0 3c0,2 2,4 3,4 2,0 4,-2 4,-4l0 -3c0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M102 151c-2,0 -4,1 -4,3l0 3c0,2 2,4 4,4 1,0 3,-2 3,-4l0 -3c0,-2 -2,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M112 151c-2,0 -4,1 -4,3l0 3c0,2 2,4 4,4 2,0 3,-2 3,-4l0 -3c0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M122 151c-2,0 -3,1 -3,3l0 3c0,2 1,4 3,4 2,0 3,-2 3,-4l0 -3c0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M132 151c-2,0 -3,1 -3,3l0 3c0,2 1,4 3,4 2,0 3,-2 3,-4l0 -3c0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M142 151c-2,0 -3,1 -3,3l0 3c0,2 1,4 3,4 2,0 4,-2 4,-4l0 -3c0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M152 151c-1,0 -3,1 -3,3l0 3c0,2 2,4 3,4 2,0 4,-2 4,-4l0 -3c0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M163 151c-2,0 -4,1 -4,3l0 3c0,2 2,4 4,4 1,0 3,-2 3,-4l0 -3c0,-2 -2,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M176 154c0,-2 -1,-3 -3,-3 -2,0 -4,1 -4,3l0 3c0,2 2,4 4,4 2,0 3,-2 3,-4l0 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M27 181l-20 0 0 -17c0,-2 -2,-3 -4,-3 -1,0 -3,1 -3,3l0 24 27 0c2,0 3,-2 3,-3 0,-2 -1,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M200 161c-2,0 -4,1 -4,3l0 17 -17 0c-1,0 -3,2 -3,4 0,1 2,3 3,3l24 0 0 -24c0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M176 15c-2,0 -3,2 -3,4 0,1 1,3 3,3l20 0 0 17c0,2 2,3 4,3 2,0 3,-1 3,-3l0 -24 -27 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3 42c2,0 4,-1 4,-3l0 -17 17 0c2,0 3,-2 3,-3 0,-2 -1,-4 -3,-4l-24 0 0 24c0,2 2,3 3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M200 93l-197 0c-1,0 -3,2 -3,4 0,1 2,3 3,3l197 0c2,0 3,-2 3,-3 0,-2 -1,-4 -3,-4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/Barcode.6491bcd123a1881f6f59b7869592013c.svg";
export { ForwardRef as ReactComponent };